<table
  *ngIf="itemList.length"
  datatable
  class="auction-dt table table-striped"
  [dtOptions]="dtOptions"
>
  <thead class="">
    <tr>
      <th class="sorting_disabled"></th>
      <th
        *ngFor="let item of headingOrder"
        [ngClass]="{ 'sticky-item-registe': item === 'Registration number' }"
        [class.sticky-item-modal]="item === 'Model'"
      >
        {{ item }}
      </th>
      <!-- <th>Added In</th> -->
      <ng-container
        *ngFor="let rowItem of itemList[0]?.['description_data'] | keyvalue"
      >
        <th
          *ngIf="
            !itemOrdername.includes(rowItem.key) && rowItem.key !== 'price'
          "
        >
          {{ rowItem.key }}
        </th>
      </ng-container>
      <th *ngIf="showLocation">location</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of itemList; index as i">
      <td>
        <div class="auction-dt-tableImage">
          <img [src]="item['frontImg']" />
        </div>
      </td>
      <ng-container *ngIf="item['description_data']">
        <ng-container *ngFor="let orderData of itemOrdername">
          <td
            [ngClass]="{ 'sticky-item-register': orderData === 'Plate Number' }"
            [class.sticky-item-modal]="orderData === 'Model'"
          >
            <!-- <ng-container *ngIf="orderData === 'Added In'">
              {{item?.['inventory_location'] || '--'}}
            </ng-container> -->

            <ng-container
              *ngIf="
                orderData === 'Status' || orderData === 'Added In';
                else others
              "
            >
              <ng-container *ngIf="orderData === 'Status'">
                <div class="d-flex align-items-center">
                  <!-- <p class="mr-1">
                    {{
                      item["description_data"][orderData] === true
                        ? "Active"
                        : "Inactive"
                    }}
                  </p> -->
                  <button
                    class="updateBtn"
                    [ngClass]="
                      item['description_data'][orderData] === true
                        ? 'active'
                        : 'inactive'
                    "
                    (click)="
                      updateStatus(
                        item['product_id'],
                        item['description_data'][orderData] === true
                          ? false
                          : true,
                        i
                      )
                    "
                    [ladda]="updateLoader[i]"
                  >
                    {{
                      item["description_data"][orderData] === true
                        ? "Active"
                        : "Inactive"
                    }}
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="orderData === 'Added In'">
                {{item?.['inventory_location'] || '--'}}
              </ng-container>
            </ng-container>

            <ng-template #others>
              <p>
                {{
                  item["description_data"][orderData]
                    ? item["description_data"][orderData]
                    : "N/A"
                }}
              </p>
            </ng-template>
          </td>
        </ng-container>
      </ng-container>
      <!-- <td>{{item?.['inventory_location'] || '--'}}</td> -->
      <ng-container *ngFor="let rowItem of item['description_data'] | keyvalue">
        <td
          *ngIf="
            !itemOrdername.includes(rowItem.key) && rowItem.key !== 'price'
          "
        >
          <p>
            {{ rowItem.value ? rowItem.value : "N/A" }}
          </p>
        </td>
      </ng-container>

      <td *ngIf="showLocation">
        {{ item.location ? item.location : "--" }}
      </td>
      <td>
        <div class="auction-dt-tableTool" *ngIf="item && !inAuction">
          <!-- {{ item["buy_status"] === "0" ? item["product_id"] : item["payment_uuid"] }} -->
          <!-- routerLink="{{ navigateToView }}{{ navigateId }}" -->
          <button
            type="button"
            *ngIf="actionKeys.includes('view')"
            class="btn btn__util"
            (click)="viewProduct(item['product_id'], i)"
          >
            <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
          </button>
          <button
            type="button"
            *ngIf="actionKeys.includes('edit')"
            class="btn btn__util color-yellow p-2"
            [disabled]="item.vam"
            routerLink="{{ navigateToEdit }}{{ item['product_id'] }}"
          >
            <i class="las la-pen ion-2x"></i>
          </button>
          <button
            type="button"
            *ngIf="actionKeys.includes('delete')"
            class="btn btn__util"
            [disabled]="item.vam"
            (click)="removeVehicleItem(i, item['product_id'])"
          >
            <ion-icon name="trash" class="ion-lg color-red"></ion-icon>
          </button>
        </div>
        <!-- start -->
        <div class="auction-dt-tableTool flex-column" *ngIf="inAuction">
          <button
            type="button"
            type="button"
            class="btn btn__util p-0"
            [disabled]="item['individualReopenDisable']"
            routerLink="/dashboard/auction/edit/{{
              item['auction_id']
            }}"
          >
            <i class="las la-redo-alt ion-lg mr-1"></i>
            REOPEN
          </button>
          <button
            type="button"
            type="button"
            class="btn btn__util p-0"
            [disabled]="item['individualReopenDisable']"
            (click)="removeVehicleItem(i, item['auction_id'])"
          >
            <ion-icon name="trash" class="ion-lg color-red mr-1"></ion-icon>
            DELETE
          </button>
        </div>
        <!-- end -->
      </td>
    </tr>
  </tbody>
</table>
